import { CardStatus } from '../../../Prototype/Level/Card/CardStatus';
import {
    TActionType,
    TransactionType,
} from '../../../Utility/Tracking/DataSet/Transaction';
import { gameTracking } from '../../../Utility/Tracking/FBLegacyTracking';
import { FBTrackingEvent } from '../../../Utility/Tracking/FBTrackingEvent';
import { track, TrackMethod } from '../../../Utility/Tracking/Track';
import { trackTransaction } from '../../../Utility/Tracking/TrackingHelpers/Transaction';
import { IGameState } from '../../Game/IGameState';
import { setBoosterUndo } from '../../Player/PlayerInventoryHelper';
import CardStateHelper from '../CardStateHelper';
import { CardTask } from '../CardTasks';
import BaseBoosterBehavior from './BaseBoosterBehavior';

export default class UndoBoosterBehavior extends BaseBoosterBehavior {
    public play(state: IGameState): IGameState {
        const lastMove =
            state.levelState.cardsState.undoHistory[
                state.levelState.cardsState.undoHistory.length - 1
            ];

        // Move card back to in-play.
        if (lastMove.cardState === CardStatus.IN_PLAY) {
            state = CardStateHelper.setCardInPlay(state, lastMove.id);

            // Task for animation.
            state = CardStateHelper.setStateTaskData(state, {
                task: CardTask.UNDO_MATCH,
                cards: [lastMove.id],
            });
        }

        // Move card back to stack.
        if (lastMove.cardState === CardStatus.IN_STACK) {
            state = CardStateHelper.setCardInStack(state, lastMove.id);

            // Task for animation.
            state = CardStateHelper.setStateTaskData(state, {
                task: CardTask.UNDO_FOLD,
                cards: [lastMove.id],
            });
        }

        state = {
            ...state,
            levelState: {
                ...state.levelState,
                cardsState: {
                    ...state.levelState.cardsState,
                    // Revert card to previous state by ID.
                    cards: {
                        ...state.levelState.cardsState.cards,
                        [lastMove.id]: { ...lastMove },
                    },

                    // Slice of new array with last element removed.
                    undoHistory: state.levelState.cardsState.undoHistory.slice(
                        0,
                        state.levelState.cardsState.undoHistory.length - 1
                    ),

                    // Reset streak score but keep the sequence.
                    streakScore: 0,
                },
            },
        };

        return this.consumeItemOrCoins(state);
    }

    public isPlayable(state: IGameState): boolean {
        return (
            state.levelState.cardsState.undoHistory.length > 0 &&
            super.isPlayable(state)
        );
    }

    protected getPrice(state: IGameState): number {
        return state.levelState.boosterPrices.undo;
    }

    protected getInventoryItem(state: IGameState): number {
        return state.playerState.inventory.boosterUndo;
    }

    protected spendInventoryItem(state: IGameState): IGameState {
        gameTracking(FBTrackingEvent.TapOnUndoMove);
        track('mUndoUsed', 1, TrackMethod.ADD);
        track('tUndoUsed', 1, TrackMethod.ADD);
        trackTransaction(
            state,
            TransactionType.INVENTORY,
            TActionType.BOOSTER_USE
        );

        return {
            ...state,
            playerState: setBoosterUndo(
                state.playerState,
                state.playerState.inventory.boosterUndo - 1
            ),
        };
    }

    protected spendCoins(state: IGameState): IGameState {
        state = super.spendCoins(state);

        gameTracking(FBTrackingEvent.TapOnUndoMove);
        track('mUndoUsed', 1, TrackMethod.ADD);
        track('tUndoUsed', 1, TrackMethod.ADD);

        // Increase the price (+25).
        return {
            ...state,
            levelState: {
                ...state.levelState,
                boosterPrices: {
                    ...state.levelState.boosterPrices,
                    undo: this.getPrice(state) + 25,
                },
            },
        };
    }
}
